import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Form, Input, Select } from 'antd';
import { EditableContext } from './AssetClassManagement';
import CustomSelect from '../../components/CustomSelect/CustomSelect';
import CustomCheckbox from '../../components/CustomCheckbox/CustomCheckbox';

const EditableCell = ({
  title,
  editing,
  children,
  dataIndex,
  record,
  handleSave,
  assetCategories,
  assets,
  ...restProps
}) => {
    // console.log('🚀 ~ EditableCell ~ record:', record);
  const form = useContext(EditableContext);

  useEffect(() => {
    if (dataIndex) {
      form.setFieldsValue({
        [dataIndex]: record[dataIndex],
      });
    }
  }, [dataIndex]);

  useEffect(() => {
    if (editing && dataIndex === 'name' && record) {
      requestAnimationFrame(() => {
        try {
          const row = document.querySelector(`[data-row-key="${record?.key}"]`);
          if (!row) return;
          const input = row.querySelector('input, textarea');
          if (input) {
            input.focus();
            if (typeof input.select === 'function') input.select();
          }
        } catch (e) {
          console.error('Error focusing input:', e);
        }
      });
    }
  }, [editing, dataIndex, record?.key]);

  const getAssetName = (id) => assets.find(i => i.ID === id);

  const save = async () => {
    try {
      const values = await form.validateFields();
      console.log('🚀 ~ save ~ values:', values);
      if(dataIndex === 'model_asset_class_id') {
        console.log('🚀 ~ save ~  getAssetName(values.model_asset_class_id):',  getAssetName(values.model_asset_class_id));
        values.financialAssetCategoryID = getAssetName(values.model_asset_class_id)?.financialAssetCategory?.ID ?? null;
      }
      handleSave({
        ...record,
        ...values,
      });
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  };

  const textSort = (a, b, direction = 1) => {
    if (a?.toLowerCase() < b?.toLowerCase()) {
      return -1 * direction;
    }
    if (a?.toLowerCase() > b?.toLowerCase()) {
      return 1 * direction;
    }
    return 0;
  };

  if (editing) {
    return (
      <td {...restProps}>
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          valuePropName={dataIndex === 'is_virtual' ? 'checked' : 'value'}
        >
          {dataIndex === 'name' ? (
            <Input
              className="custom-input full-width"
              style={{ width: '100%' }}
              onChange={save}
              placeholder={record[title]}
            />
          ) : dataIndex === 'financialAssetCategoryID' && !record.is_virtual ? (
            <CustomSelect
              width="360px"
              className="custom-select"
              onSelect={save}
              placeholder={record[title]}
            >
              {assetCategories
                ?.slice()
                ?.sort((a, b) => textSort(a.name, b.name))
                ?.map(({ ID, name }) => (
                  <Select.Option key={ID} value={ID}>
                    {name}
                  </Select.Option>
                ))}
            </CustomSelect>
          ) : dataIndex === 'is_virtual' ? (
            <CustomCheckbox checked={record[dataIndex]} onChange={save} />
          ) : dataIndex === 'model_asset_class_id' && record.is_virtual ? 
            <CustomSelect
                width="360px"
                className="custom-select"
                onSelect={save}
                placeholder={record[title]}
              >
                {assets
                  ?.slice()
                  ?.filter(i => !i.is_virtual)
                  ?.sort((a, b) => textSort(a.name, b.name))
                  ?.map(({ ID, name }) => (
                    <Select.Option key={ID} value={ID}>
                      {name}
                    </Select.Option>
                  ))}
              </CustomSelect>
            :(
              <td {...restProps}>{children}</td>
          )}
        </Form.Item>
      </td>
    );
  } else {
    if (dataIndex === 'is_virtual') {
      return <td><CustomCheckbox checked={record[dataIndex]} style={{ cursor: 'default'}} /></td>;
    } else {
      return <td {...restProps}>{children}</td>;
    }
  }
};

export default EditableCell;

EditableCell.propTypes = {
  title: PropTypes.node,
  editing: PropTypes.bool,
  children: PropTypes.node,
  dataIndex: PropTypes.string,
  record: PropTypes.object,
  handleSave: PropTypes.func,
  assetCategories: PropTypes.array,
  assets: PropTypes.array,
};
